import { cpfValidator } from "src/util/cpfValidator";
import { cnpjValidator } from "src/util/cnpjValidator";

export function cpfCnpjValidator(value: string): boolean {
    if (cpfValidator(value) || cnpjValidator(value)) {
        return true;
    } else {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/util/cpfCnpjValidator.ts